package com.macrofocus.eflux.data

import com.macrofocus.common.units.Quantity
import org.molap.dataframe.rowmajor.RowMajorDataFrame
import kotlin.reflect.KClass

class BusPowerFlowColumn(val name: String, override val type: KClass<*>, val value: (BusPowerFlowRecord) -> Any?) : RowMajorDataFrame.Column<BusPowerFlowRecord,Any?> {
    override fun getValue(row: BusPowerFlowRecord): Any? {
        return value(row)
    }

    override fun toString(): String {
        return "$name"
    }

    companion object {
        val name = BusPowerFlowColumn("name", String::class, { it.name })
        val i = BusPowerFlowColumn("i", String::class, { it.i })
        val baskv = BusPowerFlowColumn("baskv", Double::class, { it.baskv })
        val ide = BusPowerFlowColumn("ide", Double::class, { it.ide })
        val area = BusPowerFlowColumn("area", Int::class, { it.area })
        val zone = BusPowerFlowColumn("zone", Int::class, { it.zone })
        val owner = BusPowerFlowColumn("owner", Double::class, { it.owner })
        val vm = BusPowerFlowColumn("vm", Quantity::class, { it.vm })
        val va = BusPowerFlowColumn("va", Quantity::class, { it.va })
        val nvhi = BusPowerFlowColumn("nvhi", Quantity::class, { it.nvhi })
        val nvlo = BusPowerFlowColumn("nvlo", Quantity::class, { it.nvlo })
        val evhi = BusPowerFlowColumn("evhi", Quantity::class, { it.evhi })
        val evlo = BusPowerFlowColumn("evlo", Quantity::class, { it.evlo })

        val all: Array<BusPowerFlowColumn> =
            arrayOf(i, name, baskv, ide, area, zone, owner, vm, va, nvhi, nvlo, evhi, evlo)

        val meaningful: Array<BusPowerFlowColumn> =
            arrayOf(name, baskv, ide, area, zone, owner, vm, va, nvhi, nvlo, evhi, evlo)

        val selected: Array<BusPowerFlowColumn> =
            arrayOf(name, baskv, ide, area)
    }
}